import { Button, Modal } from 'react-bootstrap';
import './SupportBadge.scss';
import { MdOutlineContactSupport as ContactSupportIcon } from 'react-icons/md';
import { useState } from 'react';

const SUPPORT_EMAIL_ADDRESS = process.env.REACT_APP_EMAIL_SUPPORT || null;
const SUPPORT_PHONE_NUMBER = process.env.REACT_APP_PHONE_SUPPORT || null;

export const SupportBadge = () => {
    const [showStatus, setShowStatus] = useState(false);

    const handleToggle = () => setShowStatus(!showStatus);

    if (!SUPPORT_EMAIL_ADDRESS && !SUPPORT_PHONE_NUMBER) return null;

    return (
        <>
            <Button className="SupportBadge p-2" onClick={handleToggle}>
                <ContactSupportIcon size={42} />
            </Button>
            <Modal show={showStatus} onHide={handleToggle}>
                <Modal.Body className="text-center">
                    <div className="h3 text-center mb-4">Contact us</div>
                    <p className="mb-4">
                        You can contact us at{' '}
                        {SUPPORT_EMAIL_ADDRESS && (
                            <a href={'mailto:' + SUPPORT_EMAIL_ADDRESS}>
                                {SUPPORT_EMAIL_ADDRESS}
                            </a>
                        )}
                        {SUPPORT_EMAIL_ADDRESS && SUPPORT_PHONE_NUMBER && (
                            <> or </>
                        )}
                        {SUPPORT_PHONE_NUMBER && (
                            <a href={'tel:+1' + SUPPORT_PHONE_NUMBER}>
                                {SUPPORT_PHONE_NUMBER}
                            </a>
                        )}
                    </p>
                    <Button variant="primary" onClick={handleToggle}>
                        Close
                    </Button>
                </Modal.Body>
            </Modal>
        </>
    );
};
